var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import { styled } from 'styled-components';
import { Tooltip } from '@hn-ui/tooltips';
import { BlueExternalLink } from '@hn-ui/links';
import { Help } from '@hn-ui/icons';
import { StuckStudentsTable } from './StuckStudentsTable';
import { Text } from './Common';
import { ShowAllButton } from './ShowAll';
import { useToggle } from '@hn-front/utils';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../hooks/useWeeklyDashboardAnalytics';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-140vivw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding: 24px 32px;\n  flex-direction: column;\n  gap: 24px;\n  border-radius: 0px 16px 16px 0px;\n  border-left: 8px solid ", ";\n  background: #fff;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);\n"], ["\n  display: flex;\n  padding: 24px 32px;\n  flex-direction: column;\n  gap: 24px;\n  border-radius: 0px 16px 16px 0px;\n  border-left: 8px solid ", ";\n  background: #fff;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
});
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-1a6z1pt" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var maxPerPage = 2;
var StuckStudents = forwardRef(function (_a, ref) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    var _b = useToggle(), isToggled = _b.isToggled, toggle = _b.toggle;
    var currentStudents = isToggled ? data : data.slice(0, maxPerPage);
    var showShowAllButton = data.length > maxPerPage;
    var sendEvent = useWeeklyDashboardAnalytics();
    var handleShowAllClick = useCallback(function () {
        toggle();
        sendEvent(isToggled
            ? WeeklyDashboardEvents.stuckShowLessClick
            : WeeklyDashboardEvents.stuckShowAllClick);
    }, [isToggled, toggle, sendEvent]);
    return (_jsxs(Container, __assign({ ref: ref }, rest, { children: [_jsxs(Title, { children: ["Stuck Students", _jsx(Tooltip, __assign({ content: _jsx(TooltipContent, { onLinkClick: function () {
                                return sendEvent(WeeklyDashboardEvents.stuckTooltipLinkClick);
                            } }, void 0), maxWidth: '100%' }, { children: _jsx(Help, { color: 'black70', onMouseEnter: function () {
                                return sendEvent(WeeklyDashboardEvents.stuckHelpIconHover);
                            } }, void 0) }), void 0)] }, void 0), _jsx(StuckStudentsTable, { data: currentStudents }, void 0), showShowAllButton && (_jsx(ShowAllButton, { studentCount: data.length, onClick: handleShowAllClick, toggled: isToggled }, void 0))] }), void 0));
});
var TooltipContainer = styled.div.withConfig({ displayName: "TooltipContainer", componentId: "sc-1yegg5c" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var NewText = styled(Text).withConfig({ displayName: "NewText", componentId: "sc-7xrh3t" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red60;
});
var HelpLink = styled(BlueExternalLink).withConfig({ displayName: "HelpLink", componentId: "sc-1puwcqx" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: fit-content;\n"], ["\n  width: fit-content;\n"])));
export var TooltipContent = forwardRef(function (_a, ref) {
    var showNewLabel = _a.showNewLabel, onLinkClick = _a.onLinkClick;
    return (_jsxs(TooltipContainer, __assign({ ref: ref }, { children: [showNewLabel && _jsx(NewText, { children: "new" }, void 0), _jsx(Text, { children: "These students have spent more\n      time than expected attempting\n      to complete their tasks." }, void 0), _jsx(HelpLink, __assign({ href: 'https://help.happynumbers.com/en/articles/9405419-stuck-students', onClick: onLinkClick }, { children: "Learn more" }), void 0)] }), void 0));
});
export { StuckStudents };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
